import React from 'react'

import T from 'components/FormattedMessage'
import FriendListItem from 'components/FriendListItem'

import { List, ListItem, Typography } from '@material-ui/core'

import { IUser } from 'protos'

import FriendSlideshow from './components/FriendSlideshow'

interface Props {
  selectedFriendIds: Set<string>
  invitedFriendIds?: Set<string>
  friends?: (Array<IUser> | null)
  onFriendSelect: (friend: IUser) => void
  onFriendDeselect: (friend: IUser) => void
}

const SelectFriends: React.SFC<Props> = ({
  selectedFriendIds,
  invitedFriendIds,
  friends,
  onFriendSelect,
  onFriendDeselect,
}) => {
  const selectedFriends = (friends || [])
    .filter(friend => (
      selectedFriendIds.has(friend.userId!) &&
      (!invitedFriendIds || !invitedFriendIds.has(friend.userId!))
    ))

  const onFriendClick = (friend: IUser) => {
      const friendId = friend.userId!

      if (invitedFriendIds && invitedFriendIds.has(friendId)) {
        // noop
      } else if (!selectedFriendIds.has(friendId)) {
        onFriendSelect(friend)
      } else {
        onFriendDeselect(friend)
      }
    }

  return (
    <>
      {selectedFriendIds.size > 0 && <FriendSlideshow friends={selectedFriends} onClick={onFriendClick} />}
      <List>
        <ListItem divider>
          <Typography variant="caption" color="textSecondary">
            <T id="friends_section_friends" />
          </Typography>
        </ListItem>
        {(friends || []).map((friend, i) => (
          <FriendListItem
            key={i}
            friend={friend}
            selected={(
              selectedFriendIds.has(friend.userId!) ||
              (invitedFriendIds && invitedFriendIds.has(friend.userId!))
            )}
            onClick={() => onFriendClick(friend)}
          />
        ))}
      </List>
    </>
  )
}

export default SelectFriends
